class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      const el = document.getElementById(section.id);
      if (!el) return;
      const html = parsedState.sections && parsedState.sections[section.id];
      if (!html) return;
      el.innerHTML = this.getSectionInnerHTML(html, section.selector);
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    const productSelector = this.cartItemKey
      ? `[id="cart-notification-product-${this.cartItemKey}"]`
      : '.cart-item';

    return [
      {
        id: 'cart-notification-product',
        selector: productSelector,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    if (selector === '.cart-item') {
      const items = parsed.querySelectorAll('.cart-item');
      if (items.length) {
        const wrapper = document.createElement('div');
        items.forEach((item) => wrapper.appendChild(item.cloneNode(true)));
        return wrapper.innerHTML;
      }
      const section = parsed.querySelector('.shopify-section');
      return section ? section.innerHTML : '';
    }
    const el = parsed.querySelector(selector);
    return el ? el.innerHTML : '';
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);

/* ── Correcteur NaN global — affiche uniquement les produits venant d'être ajoutés ── */
(function () {
  /* Stocke les produits du dernier /cart/add.js */
  var lastAddedItems = null;

  function buildProductList(items) {
    var list = document.createElement('div');
    list.className = 'aurovra-notif-products';
    list.style.cssText = 'padding:4px 0 10px;font-family:"DM Sans",sans-serif;font-size:13px;color:#2C2C2C;line-height:1.8';
    items.forEach(function (item) {
      var p = document.createElement('p');
      p.style.cssText = 'margin:0;padding:1px 0';
      p.textContent = item.product_title;
      list.appendChild(p);
    });
    return list;
  }

  function fixNaN() {
    if (document.querySelector('.aurovra-notif-products')) return;

    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null, false);
    var nanParents = [];
    var seen = [];
    var node;
    while ((node = walker.nextNode())) {
      if (!node.nodeValue || node.nodeValue.indexOf('NaN') === -1) continue;
      var parent = node.parentElement;
      if (!parent || seen.indexOf(parent) !== -1) continue;
      if (window.getComputedStyle(parent).display === 'none') continue;
      seen.push(parent);
      nanParents.push(parent);
    }

    if (!nanParents.length) return;

    function applyFix(items) {
      nanParents.forEach(function (el) { el.style.display = 'none'; });
      var ref = nanParents[0];
      if (ref && ref.parentNode) ref.parentNode.insertBefore(buildProductList(items), ref);
    }

    if (lastAddedItems && lastAddedItems.length) {
      /* On connaît exactement ce qui vient d'être ajouté */
      applyFix(lastAddedItems);
    } else {
      /* Fallback : lit le panier entier (ne devrait pas arriver) */
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { applyFix(cart.items); })
        .catch(function () { nanParents.forEach(function (el) { el.style.display = 'none'; }); });
    }
  }

  function clearPreviousFix() {
    var old = document.querySelectorAll('.aurovra-notif-products');
    for (var i = 0; i < old.length; i++) old[i].remove();
  }

  function scheduleChecks() {
    clearPreviousFix();
    [300, 700, 1200, 2000, 3500].forEach(function (ms) { setTimeout(fixNaN, ms); });
  }

  /* MutationObserver sur body : attrape la popup Katching dès qu'elle est injectée */
  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var el = added[j];
        if (el.nodeType === 1 && el.textContent && el.textContent.indexOf('NaN') !== -1) {
          clearPreviousFix();
          setTimeout(fixNaN, 50);
          return;
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });

  /* Intercepte fetch — lit la réponse de /cart/add.js pour savoir ce qui vient d'être ajouté */
  var _fetch = window.fetch;
  window.fetch = function (url) {
    var result = _fetch.apply(this, arguments);
    if (typeof url === 'string' && url.indexOf('/cart/add') !== -1) {
      result.then(function (response) {
        return response.clone().json();
      }).then(function (data) {
        /* Shopify renvoie { items:[...] } pour un ajout multiple, ou l'objet item directement */
        lastAddedItems = data.items || (data.id ? [data] : null);
        scheduleChecks();
      }).catch(function () {
        lastAddedItems = null;
        scheduleChecks();
      });
    }
    return result;
  };

  /* Intercepte XHR (certaines versions de Katching utilisent XHR) */
  var _open = XMLHttpRequest.prototype.open;
  var _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._isCartAdd = typeof url === 'string' && url.indexOf('/cart/add') !== -1;
    return _open.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this._isCartAdd) {
      var xhr = this;
      xhr.addEventListener('load', function () {
        try {
          var data = JSON.parse(xhr.responseText);
          lastAddedItems = data.items || (data.id ? [data] : null);
        } catch (e) {
          lastAddedItems = null;
        }
        scheduleChecks();
      });
    }
    return _send.apply(this, arguments);
  };

  /* Fallback : cart-notification natif Shopify */
  var notifEl = document.getElementById('cart-notification');
  if (notifEl) {
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        if (m.type === 'attributes' && notifEl.classList.contains('active')) scheduleChecks();
      });
    }).observe(notifEl, { attributes: true, attributeFilter: ['class'] });
  }
})();

